export const locale = {
  lang: 'fr-CA',
  data: {
    QUICK_ORDER: {
      TITLE: 'Nouvelle Cueillette',
      CLIENTS_TITLE: 'Clients',
      BY_CLIENT: 'Filtrer par client',
      BY_ENTERPRISE: 'Filtrer par entreprise',
      ORDERING_CLIENT: 'Client qui commande',
      INVOICING_CLIENT: 'Client à facturer',
      SAME_CLIENT_BOTH: 'Choisir le même client pour commander et facturer',
      COPY_START_DATE: 'Copier la date de départ',
    },
  },
};
